import React from "react";
import { motion } from "framer-motion";


const RollingText = () => {

  return (
    <motion.div
      initial={{ y: 500 }}
      animate={{
        y: [
            150, 150, -100, -100, -100, -100, -550, -550, -550, -550, -1000, -1000,
          -1000, -1000, -1450, -1450, -1450, -1450, -1900, -1900, -1900, -1900, -2350,
          -2350, -2350, -2350,
        ],
        opacity: [
            0.2,1,0.2,0.8,1,1,0.8,0,0.8,1,1,0.8,0.2,0.8,1,1,0.8,0.2,0.8,1,1,0.8,0.2,0.8,1,1,0.8,0.2,0.8,1,1,0.8,1
        ],
      }}
      transition={{ duration: 42 }}
      className="RollingText"
    >
      <div className="rollingText__word">visit</div>
      <div className="rollingText__word">grow</div>
      <div className="rollingText__word">inspire</div>
      <div className="rollingText__word">connect</div>
      <div className="rollingText__word">succeed</div>
      <div className="rollingText__word">visit</div>
    </motion.div>
  );
};

export default RollingText;
